export default "__VITE_ASSET__DS$GPhcj__"